<template>
  <section>
    <div class="container pt-5">
      <div class="row">
        <h4 class="text-left mb-3">
          特色活動
        </h4>
      </div>
    </div>
    <RegionSelect @selectCity="selectCityHandler" />
    <div
      class="container py-5"
    >
      <div class="row mb-4">
        <div
          v-if="activitiesByCity?.length"
          class="d-flex align-items-center h5"
        >
          <div class="me-3">
            {{ currentCity.CityName }}
          </div>
          <small class="text-small text-secondary">共有 <span class="text-success">{{ allDataLength }}</span> 個特色活動</small>
        </div>
        <div
          v-else
          class="me-3 text-small text-secondary"
        >
          暫無相關資料。
        </div>
      </div>
      <div class="row">
        <div
          v-if="activitiesByCity?.length"
          class="col-md-12 px-0"
        >
          <div class="row d-flex justify-content-start">
            <div
              v-for="activity in activitiesByCity"
              :key="activity.ActivityID"
              class="col-md-6 col-xl-3 mb-4"
            >
              <Card
                :title="activity.ActivityName"
                :content="activity"
                :location="activity.Location"
                :show-category="true"
                :show-location="true"
                @clickHandler="clickHandler"
              />
            </div>
          </div>
          <div
            v-if="activitiesByCity?.length"
            class="d-flex justify-content-center my-5"
          >
            <Pagination
              :current-page="page"
              :pages="pages"
              @changePage="changePageHandler"
            />
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { useStore } from 'vuex'
import { ref, computed, watch } from 'vue'
import Card from '@/components/Card'
import Pagination from '@/components/Pagination'
import RegionSelect from '@/components/RegionSelect'

export default {
  name: 'Activity',
  components: {
    Card,
    Pagination,
    RegionSelect
  },
  setup () {
    const store = useStore()
    const currentCity = ref('')
    const page = ref(1)

    const selectCityHandler = (city) => {
      currentCity.value = city
    }

    watch(currentCity, (newValue) => {
      if (newValue) {
        getActivityHandler(newValue.CityEngName)
      }
    })

    // 取得所有活動資料
    const getActivityHandler = (city) => {
      store.dispatch('GET_ACTIVITY_BY_CITY', {
        city: city,
        sorted: {
          $top: 30,
          $format: 'JSON'
        }
      })
      store.dispatch('GET_ACTIVITY_BY_CITY_All_PAGES', city)
      resetPage()
    }

    const resetPage = () => {
      page.value = 1
    }

    // 活動
    const activitiesByCity = computed(() => store.getters.activitiesByCity)

    const allDataLength = computed(() => store.getters.allDataLength)

    const pages = computed(() => store.getters.pages)

    const clickHandler = (content) => {
      window.open('https://www.google.com.tw/search?q=' + content.ActivityName, '_blank')
    }

    const scrollToTop = () => {
      window.scrollTo(0, 0)
    }
    const changePageHandler = (index) => {
      page.value = index
      store.dispatch('GET_ACTIVITY_BY_CITY', {
        city: currentCity.value.CityEngName,
        sorted: {
          $top: 30,
          $format: 'JSON',
          $skip: (page.value - 1) * 30
        }
      })
      scrollToTop()
    }

    return {
      currentCity,
      activitiesByCity,
      clickHandler,
      selectCityHandler,
      allDataLength,
      pages,
      page,
      changePageHandler
    }
  }
}
</script>

<style lang="scss" scoped>
.badge{
  position: relative;
  cursor: pointer;
  &.active {
  &::before {
    content: "";
    position: absolute;
    display: block;
    left: 50%;
    bottom: .35rem;
    width: .85rem;
    height: 4px;
    border-radius: 6px;
    background-color:  #10CC9F;
    transform:translate(-50%,0);
  }
  }
}

.icon{
  width: 1.45rem;
  transform: translateX(-.75rem);
}

.bg-dark-light{
  background:  #F2F2F2;
  border-right:1px solid #DEDEDE;
  position: relative;
   &::before {
    position: absolute;
    width: 1rem;
    height: 1rem;
    right: -1rem;
    top: 50%;
    transform: translateY(-50%);
    content: "";
    background-image: url("../assets/image/Polygon.svg");
    background-repeat: no-repeat;
    background-size: contain;
  }
}

.border-left-radius{
  border-top-left-radius: 0.75rem;
  border-bottom-left-radius: 0.75rem;
}

.border-right-radius{
  border-top-right-radius: 0.75rem;
  border-bottom-right-radius: 0.75rem;
}
</style>
